import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import {
  Box,
  Button,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useSelector } from "react-redux";
import {
  selectCurrentToken,
  selectSponserID,
} from "../features/auth/authSlice";
import { tokens } from "../theme";

const userSchema = yup.object().shape({
  title: yup.string().required("required"),
  description: yup.string().required("required"),
  price: yup.number().required("required"),
  quantity: yup.number().required("required"),
});

const EditProductModal = ({
  editData,
  setShowEditModal,
  setProducts,
}: {
  editData: any;
  setShowEditModal: React.Dispatch<React.SetStateAction<boolean>>;
  setProducts: React.Dispatch<any>;
}) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [initialValues, setInitialValues] = useState({
    title: "",
    description: "",
    price: "",
    quantity: "",
  });
  const sponserId = useSelector(selectSponserID);
  const token = useSelector(selectCurrentToken);
  const [productImages, setProductImages] = useState({} as any);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  useEffect(() => {
    setInitialValues({
      description: editData.description,
      price: editData.price,
      quantity: editData.quantity,
      title: editData.title,
    });
    setProductImages(editData.imageUrls);
  }, [editData]);

  const handleFormSubmit = async (values: any) => {
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("description", values.description);
    formData.append("price", values.price);
    formData.append("quantity", values.quantity);
    Object.keys(productImages).forEach((image) => {
      formData.append("productImages", productImages[image]);
    });
    formData.append("landingPageId", editData.landingPageId);
    formData.append("productId", editData.productId);
    formData.append("sponserId", sponserId);

    const response: any = await fetch(
      process.env.REACT_APP_ENV === "local"
        ? "/sponser/editProduct"
        : process.env.REACT_APP_BACKEND_API + "/sponser/editProduct",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      }
    );
    if (response.status === 200) {
      setProducts(response.products);
    }
  };
  return (
    <div className="flex flex-col justify-center items-center fixed left-0 top-0 right-0 bottom-0 bg-[rgba(0,0,0,0.5)] z-[3]">
      <div className="p-[10px] bg-[#fff] border-[#eee]">
        <div className="p-[10px] flex justify-between">
          <Typography variant="h3" color={colors.blueAccent[400]}>
            Edit Product
          </Typography>
          <div
            className="hover:cursor-pointer"
            onClick={() => setShowEditModal(false)}
          >
            <Typography variant="h3" color={"black"}>
              X
            </Typography>
          </div>
        </div>
        <div className="w-[500px]">
          <div>
            <Formik
              onSubmit={handleFormSubmit}
              initialValues={initialValues}
              validationSchema={userSchema}
            >
              {/* @ts-ignore */}
              {({
                values,
                errors,
                touched,
                handleBlur,
                handleChange,
                handleSubmit,
              }) => {
                return (
                  <form onSubmit={handleSubmit}>
                    <Box
                      display={"grid"}
                      gap="30px"
                      gridTemplateColumns={"repeat(4, minmax(0,1fr))"}
                      sx={{
                        "& > div": {
                          gridColumn: isNonMobile ? undefined : "span 4",
                        },
                      }}
                    >
                      <TextField
                        fullWidth
                        variant="filled"
                        type={"text"}
                        label="Title"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          handleChange(e);
                          setInitialValues({
                            ...initialValues,
                            title: e.target.value,
                          });
                        }}
                        value={initialValues.title}
                        name="title"
                        error={!!touched.title && !!errors.title}
                        helperText={touched.title && errors.title}
                        sx={{ gridColumn: "span 2" }}
                      />
                      <TextField
                        fullWidth
                        variant="filled"
                        type={"text"}
                        label="Description"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          handleChange(e);
                          setInitialValues({
                            ...initialValues,
                            description: e.target.value,
                          });
                        }}
                        value={initialValues.description}
                        name="description"
                        error={!!touched.description && !!errors.description}
                        helperText={touched.description && errors.description}
                        sx={{ gridColumn: "span 2" }}
                      />
                      <TextField
                        fullWidth
                        variant="filled"
                        type={"number"}
                        label="Price"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          handleChange(e);
                          setInitialValues({
                            ...initialValues,
                            price: e.target.value,
                          });
                        }}
                        value={initialValues.price}
                        name="price"
                        error={!!touched.price && !!errors.price}
                        helperText={touched.price && errors.price}
                        sx={{ gridColumn: "span 2" }}
                      />
                      <TextField
                        fullWidth
                        variant="filled"
                        type={"number"}
                        label="Quantity"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          handleChange(e);
                          setInitialValues({
                            ...initialValues,
                            quantity: e.target.value,
                          });
                        }}
                        value={initialValues.quantity}
                        name="quantity"
                        error={!!touched.quantity && !!errors.quantity}
                        helperText={touched.quantity && errors.quantity}
                        sx={{ gridColumn: "span 2" }}
                      />
                      <div className="w-[100%]">
                        <input
                          type="file"
                          multiple
                          accept="image/jpeg"
                          onChange={(e) => setProductImages(e.target.files)}
                        />
                      </div>
                    </Box>
                    <Box display="flex" justifyContent={"start"} mt="20px">
                      <Button
                        type="submit"
                        color="secondary"
                        variant="contained"
                      >
                        Edit Product
                      </Button>
                    </Box>
                  </form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProductModal;
